import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function ProcessSection() {
  const steps = [{
    title: 'Profile Optimization',
    desc: 'Crafting a presence that commands attention across all digital touchpoints.'
  }, {
    title: 'Strategic Positioning',
    desc: 'Targeting the right opportunities at the right time with market-aligned messaging.'
  }, {
    title: 'Network Activation',
    desc: 'Leveraging connections that matter to bypass traditional application queues.'
  }, {
    title: 'Application Precision',
    desc: 'Every submission is tailored to perfection, addressing specific organizational pain points.'
  }, {
    title: 'Follow-Through Excellence',
    desc: 'The art of professional persistence that keeps you top-of-mind without being intrusive.'
  }];
  return <Section background="warm" id="process" data-id="element-337">
      <div className="max-w-4xl mx-auto" data-id="element-338">
        <FadeIn className="text-center mb-16" data-id="element-339">
          <h2 className="text-3xl md:text-4xl font-serif text-ink-900 mb-4" data-id="element-340">
            Navigating Executive Job Boards
          </h2>
          <div className="h-[1px] w-24 bg-accent-400 mx-auto" data-id="element-341" />
        </FadeIn>

        <div className="space-y-8 relative" data-id="element-342">
          <div className="absolute left-[27px] top-4 bottom-4 w-[1px] bg-accent-400/30" data-id="element-343" />

          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} className="relative flex items-start gap-8" data-id="element-344">
              <div className="relative z-10 flex-shrink-0 w-14 h-14 rounded-full bg-white border-2 border-accent-400 flex items-center justify-center shadow-sm" data-id="element-345">
                <span className="font-serif text-xl font-bold text-ink-900" data-id="element-346">
                  0{index + 1}
                </span>
              </div>
              <div className="pt-2 pb-8" data-id="element-347">
                <h3 className="text-xl font-serif font-bold text-ink-900 mb-2" data-id="element-348">
                  {step.title}
                </h3>
                <p className="text-body leading-relaxed" data-id="element-349">{step.desc}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </Section>;
}